import { render } from "./AuthScopes.vue?vue&type=template&id=58195e2a&ts=true"
import script from "./AuthScopes.vue?vue&type=script&lang=ts"
export * from "./AuthScopes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__